import { render, staticRenderFns } from "./FootSection.vue?vue&type=template&id=3e6185e3&scoped=true&"
import script from "./FootSection.vue?vue&type=script&lang=js&"
export * from "./FootSection.vue?vue&type=script&lang=js&"
import style0 from "./FootSection.vue?vue&type=style&index=0&id=3e6185e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6185e3",
  null
  
)

export default component.exports